(() => {
  const initialise = () => {
    document.querySelectorAll('[id$="__zentrixa_products_first"]').forEach(slider => {
      const root = slider.closest('slider-component');
      if (!root || root.dataset.zentrixaAutoplay) return;
      const next = root.querySelector('button[name="next"]');
      const controls = root.querySelector('.slider-buttons');
      if (!next || !controls || slider.children.length < 2) return;
      root.dataset.zentrixaAutoplay = 'ready';
      const motion = window.matchMedia('(prefers-reduced-motion: reduce)');
      let paused = motion.matches;
      let visible = false;
      const toggle = document.createElement('button');
      toggle.type = 'button';
      toggle.className = 'button button--secondary';
      toggle.style.cssText = 'font-size:12px;min-height:36px;padding:6px 12px;margin-left:12px';
      const labels = document.querySelector('[data-zentrixa-autoplay-labels]');
      const refresh = () => {
        toggle.textContent = paused ? labels?.dataset.play || 'Play automatic rotation' : labels?.dataset.pause || 'Pause automatic rotation';
        toggle.setAttribute('aria-pressed', String(!paused));
      };
      toggle.setAttribute('aria-controls', slider.id);
      toggle.addEventListener('click', () => { paused = !paused; refresh(); });
      motion.addEventListener('change', event => { if (event.matches) { paused = true; refresh(); } });
      controls.append(toggle);
      refresh();
      const observer = new IntersectionObserver(entries => { visible = entries[0].isIntersecting; }, { threshold: 0.2 });
      observer.observe(slider);
      const timer = window.setInterval(() => {
        if (!root.isConnected) { clearInterval(timer); observer.disconnect(); return; }
        if (paused || !visible || document.hidden || root.matches(':hover') || root.contains(document.activeElement)) return;
        if (next.disabled) slider.scrollTo({left: 0, behavior: 'smooth'});
        else next.click();
      }, 4500);
    });
  };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', initialise, {once: true});
  else initialise();
  document.addEventListener('shopify:section:load', initialise);
})();